import { Button, DatePicker, Form, InputNumber, Modal } from 'antd'
import FooterButtons from 'elements/Buttons/FooterButtons'
import useModalShow from 'elements/Hooks/useModalShow'
import CustomTable from 'elements/Table/CustomTable'
import { defaultFormItemLayout } from 'modules/FormItems'
import moment from 'moment'
import { get } from 'lodash'
import React, { useState } from 'react'

const def = {
  rate: 0,
  date: moment().format('YYYY-MM-DD'),
}
export function PriceHistory({ history, setHistory, object }) {
  console.log('object', object)
  const { visible, onShow: _onShow, onCancel: _onCancel, isNew } = useModalShow()
  const [current, setCurrent] = useState(def)
  console.log('history', history)

  function onShow(object, type) {
    console.log(object, type)
    setCurrent(object || def)
    _onShow(object, type)
  }

  function onCancel(props) {
    setCurrent(def)
    _onCancel(props)
  }

  async function submit() {
    console.log('submit', current)
    setHistory((e) => [...e, { ...current, key: moment().millisecond() }])
    onCancel()
  }

  async function remove() {
    console.log('remove', current)
    setHistory((e) => e.filter((i) => i.key !== current.key))
    onCancel()
  }

  async function update() {
    console.log('update', current)
    setHistory((e) => e.map((i) => (i.key === current.key ? current : i)))
    onCancel()
  }

  const columns = [
    {
      Header: 'Date',
      accessor: 'date',
      Cell: ({ value, original }) => <a onClick={() => onShow(original, 'edit')}>{value || '_NA_'}</a>,
    },
    {
      Header: 'Rate',
      accessor: 'rate',
    },
  ]

  console.log(current)

  return (
    <div>
      <Modal
        footer={
          <FooterButtons
            isNew={isNew}
            isEdit={!isNew}
            submit={submit}
            remove={remove}
            update={update}
            title={'Price History'}
          />
        }
        onCancel={onCancel}
        destroyOnClose
        title="Price History"
        visible={visible}>
        <Form.Item {...defaultFormItemLayout} label="Date">
          <DatePicker
            defaultValue={moment(get(current, 'date'))}
            onChange={(e) => {
              setCurrent({
                ...current,
                date: moment(e).format('YYYY-MM-DD'),
              })
            }}
          />
        </Form.Item>
        <Form.Item {...defaultFormItemLayout} label="Rate">
          <InputNumber
            defaultValue={get(current, 'rate')}
            onChange={(e) =>
              setCurrent({
                ...current,
                rate: e,
              })
            }
          />
        </Form.Item>
      </Modal>
      <CustomTable
        columns={columns}
        data={history}
        CreateButton={() => (
          <Button type="primary" onClick={() => onShow()}>
            New Price
          </Button>
        )}
      />
    </div>
  )
}
